const provinces = {
	en: [{
		key: "location",
		title: "Location",
		filters: [
			{name: "Alberta", slug: "AB"},
			{name: "British Columbia", slug: "BC"},
			{name: "Manitoba", slug: "MB"},
			{name: "New Brunswick", slug: "NB"},
			{name: "Newfoundland and Labrador", slug: "NL"},
			{name: "Northwest Territories", slug: "NT"},
			{name: "Nova Scotia", slug: "NS"},
			{name: "Nunavut", slug: "NU"},
			{name: "Ontario", slug: "ON"},
			{name: "Prince Edward Island", slug: "PE"},
			{name: "Quebec", slug: "QC"},
			{name: "Saskatchewan", slug: "SK"},
			{name: "Yukon", slug: "YT"},
			{name: "Online", slug: "online"},
		],
	}],
	fr: [{
		key: "location",
		title: "Lieu",
		filters: [
			{name: "Alberta", slug: "AB"},
			{name: "Colombie-Britannique", slug: "BC"},
			{name: "Manitoba", slug: "MB"},
			{name: "Nouveau-Brunswick", slug: "NB"},
			{name: "Terre-Neuve-et-Labrador", slug: "NL"},
			{name: "Territoires du Nord-Ouest", slug: "NT"},
			{name: "Nouvelle-Écosse", slug: "NS"},
			{name: "Nunavut", slug: "NU"},
			{name: "Ontario", slug: "ON"},
			{name: "Île-du-Prince-Édouard", slug: "PE"},
			{name: "Québec", slug: "QC"},
			{name: "Saskatchewan", slug: "SK"},
			{name: "Yukon", slug: "YT"},
			{name: "En ligne", slug: "online"},
		]
	}]
};

export default provinces;